import React, { Component } from "react";
import * as Constants from "../../common/Global/constants";
import { SearchSpan } from "../../common/Global/globalStyles.style";
import FilterDropDown from "../../common/DropdownMenus/FilterDropdown";
import AlertDialog from "../../common/AlertDialog";
import Pagination from "../../common/Global/pagination";
import {
    getLocalStorageVariables,
    getThemeSettingsVariables,
    isEmptyVariable,
    sortTable,
    truncateString,
    isEmptyArray,
    getStringWithSpaceAfterComma,
    handleTokenExpiry
} from "../../common/Global/commonFunctions";
import { BrowserRouter as Router } from "react-router-dom";
import AuditeeSidebar from "../../common/AuditeeSidebar";
import moment from "moment";
import MasterMenuTabs from "./topmenu";

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
const sortName = "c.companyName";
const sortReferenceNo = "a.referenceNo";
const sortDescription = "assignmentTypeName";
const sortEndDate = "a.endDate";
const sortReportDate = "a.reportDate";
const sortArea = "a.assignmentArea";
const sortLocation = "unitNameCityList";
const sortunitAddressList = "unitAddressList";
const sortunitCityList ="unitCityList";

const masterTypeFilterDefaultPlaceholder = "All Master Types";
const departmentDropdownDefaultValue = "Select Department";


class AuditeeDraftAssignmentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag: false,
            apiSearchKey: "",
            searchkey: "",
            currentPageNo: 1,
            showLoader: false,
            resultSize: Constants.RESULT_SIZE,
            totalCount: 0,
            datalist: [],
            resultSizePlaceholder: Constants.RESULT_SIZE,
            sort: "",
            sortDir: "",
            company:{},

            showAlertDialog: false,
            operationType: "",
            deleteReactivateId: "",
            deleteReactivateMasterType: "",
            reviewLevel: "",
            alertDialogMessage: "",
            alertDialogHeading: "",
            proceedBtnLabel: "",
            showBtnLoader:false,
            showAlertDialogInfo: false,
            alertDialogMessageInfo: "",

            showUpdateReviewDialog: false,
            showReviewHistoryDialog: false,
            resultSizeArr: Constants.RESULT_SIZE_DD_ARR,
        };
        this.masterTypeFilterArr = [];
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount() {
        this.getInitData();
    }

    resultSizeDropdownClick = (item, selectedIndex) => {
		let tempArr = this.state.resultSizeArr;
		let placeholder = "";

		for (const [i, value] of tempArr.entries()) {
			if (i === selectedIndex) {
				tempArr[i].isSelected = true;
				placeholder = value.label;
			} else {
				tempArr[i].isSelected = false;
			}
		}

		this.setState({
			resultSizeArr: tempArr,
			resultSize: item.label,
			resultSizePlaceholder: placeholder,
		},() => {
			this.getInitData();
		});
	};

    handleChangeSearch = (e) => {
		const { name, value } = e.target;

		this.setState({
			[name]: value,
		});
	};

	onSearchIconClick = () => {
		this.setState({
			currentPageNo: 1,
		},() => {
			this.getInitData();
		});
	};

	onEnterBtnPress = (e) => {
		var code = e.keyCode || e.which;
		if (code === 13) {
			this.setState({
				currentPageNo: 1,
			},() => {
				this.getInitData();
			});
		}
	};

    sortTableLocal = (sortColumn) => {
        let sortObj = sortTable(sortColumn, this.state.sort, this.state.sortDir);

        this.setState({
            sort: sortObj.sortTemp,
            sortDir: sortObj.sortDirTemp,
        },() => {
            this.getInitData();
        });
    };

    handleShowTasks = (assignmentId, unitListId, executionTemplateId) => {
        this.props.history.push(Constants.URL_AUDITEE_EMPLOYEE_DRAFT_TASKS + "/" + assignmentId,
            {
                unitListId: unitListId,
                executionTemplateId: executionTemplateId
            } 
        );
    }
        
    /*******************API CALLS*******************/
    getInitData = () => {
        this.setState({
            showLoader: true
        });

        Promise.all([
            fetch(Constants.GetAuditeeEmployeeDraftReports, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                }),
            }),
        ])
        .then(([masterRes]) => {
			return Promise.all([masterRes.json()]);
		})
        .then(([masterRes]) => {
            let datalistTemp = [];
            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if (masterRes.responseCode === Constants.CODE_SUCCESS) {
                datalistTemp = masterRes.data.result;
            } else {
            }

            this.setState({
				componentDidMountFlag: true,
                showLoader:false,
                datalist: datalistTemp,
            });
        })
    }
    /*******************API CALLS END HERE*******************/

    render() {
        return (
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <AuditeeSidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                {/* <Topbar /> */}
                                <MasterMenuTabs
                                    themeSettings={themeSettings} 
                                    showMainMenu={true}
                                />
                                
                                {this.state.showLoader && (
                                    <div class="loader"></div>
                                )}
                                {
                                    // Need to check component did mount flag, other wise until api is called,
                                    // it shows no items found layout.
                                    this.state.componentDidMountFlag && (
                                        <div className="body-wrapper">
                                            <div className="search-addnew-bg">
                                                <div className="search-addnew">
                                                    <div className="search-filter-layout">
                                                        <FilterDropDown
                                                            placeholder={this.state.resultSizePlaceholder}
                                                            dropdownArr={this.state.resultSizeArr}
                                                            onDropDownItemClick={this.resultSizeDropdownClick}
                                                            themeSettings={themeSettings}
                                                            mleft={0}
                                                        />
                                                        <div className="search-col m-l-10">
                                                            <input
                                                                name="searchkey"
                                                                type="text"
                                                                onChange={this.handleChangeSearch}
                                                                placeholder="Search"
                                                                onKeyPress={this.onEnterBtnPress}
                                                                value={this.state.searchkey}
                                                            />
                                                            <SearchSpan themeSettings={themeSettings} onClick={this.onSearchIconClick} className="material-icons">
                                                                {" "}
                                                                search{" "}
                                                            </SearchSpan>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                !isEmptyArray(this.state.datalist) && (
                                                <div className="common-tab-bg">
                                                    <div className="common-table" style={{ width: "100%" }}>
                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center" width={"5%"}>
                                                                        No.
                                                                    </th>
                                                                    <th className="c-pointer" onClick={this.sortTableLocal.bind(this, sortReferenceNo)}>
                                                                        <div className="sort-header">
                                                                            Ref No.
                                                                            <span
                                                                                className={
                                                                                    this.state.sort === sortReferenceNo ? "material-icons" : "material-icons hide-sort-arrow"
                                                                                }
                                                                            >
                                                                                {this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
                                                                            </span>
                                                                        </div>
                                                                    </th>
                                                                    {
                                                                        this.state.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF &&
                                                                        <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortLocation)}>
                                                                            <div className="sort-header">Unit
                                                                            <span className={(this.state.sort === sortLocation)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                            </div>
                                                                        </th>
                                                                    }
                                                                    {
                                                                        this.state.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF &&
                                                                        <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortunitAddressList)}>
                                                                            <div className="sort-header">Name
                                                                            <span className={(this.state.sort === sortunitAddressList)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                            </div>
                                                                        </th>
                                                                    }
                                                                    {
                                                                        this.state.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF &&
                                                                        <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortunitCityList)}>
                                                                            <div className="sort-header">City
                                                                            <span className={(this.state.sort === sortunitCityList)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                            </div>
                                                                        </th>
                                                                    }
                                                                    {
                                                                        this.state.company?.companyType !== Constants.USER_ENGAGEMENT_TYPE_SELF &&
                                                                        <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortName)}>
                                                                            <div className="sort-header">Client
                                                                            <span className={(this.state.sort === sortName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                            </div>
                                                                        </th>
                                                                    }
                                                                    <th className="c-pointer" onClick={this.sortTableLocal.bind(this, sortDescription)}>
                                                                        <div className="sort-header">
                                                                            Type
                                                                            <span
                                                                                className={
                                                                                    this.state.sort === sortDescription
                                                                                        ? "material-icons"
                                                                                        : "material-icons hide-sort-arrow"
                                                                                }
                                                                            >
                                                                                {this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
                                                                            </span>
                                                                        </div>
                                                                    </th>
                                                                    <th className="c-pointer" onClick={this.sortTableLocal.bind(this, sortArea)}>
                                                                        <div className="sort-header">
                                                                        Scope
                                                                            <span
                                                                                className={
                                                                                    this.state.sort === sortArea ? "material-icons" : "material-icons hide-sort-arrow"
                                                                                }
                                                                            >
                                                                                {this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
                                                                            </span>
                                                                        </div>
                                                                    </th>
                                                                    <th className="c-pointer" onClick={this.sortTableLocal.bind(this, sortEndDate)}>
                                                                        <div className="sort-header">
                                                                            End Date
                                                                            <span
                                                                                className={
                                                                                    this.state.sort === sortEndDate ? "material-icons" : "material-icons hide-sort-arrow"
                                                                                }
                                                                            >
                                                                                {this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
                                                                            </span>
                                                                        </div>
                                                                    </th>
                                                                    <th className="c-pointer" onClick={this.sortTableLocal.bind(this, sortReportDate)}>
                                                                        <div className="sort-header">
                                                                            Report Date
                                                                            <span
                                                                                className={
                                                                                    this.state.sort === sortReportDate ? "material-icons" : "material-icons hide-sort-arrow"
                                                                                }
                                                                            >
                                                                                {this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
                                                                            </span>
                                                                        </div>
                                                                    </th>
                                                                    {/* <th className="text-center" width={"5%"}>
                                                                        <div className="sort-header"></div>
                                                                    </th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    !isEmptyArray(this.state.datalist) &&
                                                                    this.state.datalist.map((item, idx) => {
                                                                            let tempScop = [];
                                                                            if(!isEmptyVariable(item.functionList)){
                                                                                tempScop = item.functionList?.split(",").map((func) => func.split(":-:")[0]);
                                                                            }else if(!isEmptyVariable(item.processList)){
                                                                                tempScop = item.processList.split(",").map((func) => func.split(":-:")[0]);
                                                                            }else if(!isEmptyVariable(item.checkList)){
                                                                                tempScop = item.checkList.split(",").map((func) => func.split(":-:")[0]);
                                                                            }		
                                                                            let unitListId = !isEmptyVariable(item.unitList)?[parseInt(item.unitList.split(":-:")[1])]:"";
                                                                            														        
                                                                        return (
                                                                            <tr onClick={this.handleShowTasks.bind(this, item.assignmentId, unitListId, item.executionTemplateId)}>
                                                                            
                                                                                <td className="text-center">
                                                                                    {(this.state.currentPageNo - 1) * this.state.resultSize + ++idx}
                                                                                </td>
                                                                                <td>{item.referenceNo}</td>
                                                                                {
                                                                                    this.state.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF &&
                                                                                    <td>{truncateString(String(getStringWithSpaceAfterComma(item.unitNameCityList)).split("(")[0],100)}</td>
                                                                                }
                                                                                {
                                                                                    this.state.company?.companyType !== Constants.USER_ENGAGEMENT_TYPE_SELF &&
                                                                                    <td>{item.companyName}</td>
                                                                                }
                                                                                {   
                                                                                    this.state.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF && 
                                                                                    <td>
                                                                                    {isEmptyVariable(item.unitAddressList)? "-": String(item.unitAddressList).split(":-:")[0]}
                                                                                    </td>
                                                                                }
                                                                                {   
                                                                                    this.state.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF && 
                                                                                    <td>
                                                                                    {isEmptyVariable(item.unitCityList)? "-": item.unitCityList}
                                                                                    </td>
                                                                                }
                                                                                <td>{item.assignmentTypeName}</td>
                                                                                <td>{item.assignmentArea == "CheckList" ?
                                                                                    isEmptyArray(tempScop)?"-":(`CheckList: ` + tempScop[0]) :
                                                                                    isEmptyArray(tempScop)?"-":(tempScop.length==1?tempScop[0]:`${tempScop[0]} + ${tempScop.length-1}`)}
                                                                                </td>
                                                                                <td>{moment(item.endDate).format("DD/MM/YYYY")}</td>
                                                                                <td>{isEmptyVariable(item.reportDate)?"": moment(item.reportDate).format("DD/MM/YYYY")}</td>

                                                                                {/* <td className="text-center">
                                                                                    {actionObj.actionArr && actionObj.actionArr.length > 0 && (
                                                                                        <TableDropDown
                                                                                            actionArr={actionObj.actionArr}
                                                                                            onDropDownItemClick={this.onTableDropDownItemClick}
                                                                                            dropDownId={item}
                                                                                            dropdownWidth={actionObj.dropdownWidth}
                                                                                            themeSettings={themeSettings}
                                                                                        />
                                                                                    )}
                                                                                </td> */}
                                                                            </tr>
                                                                        );
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) && (
                                                <div class="no-items-layout">
                                                    <div class="no-items-card">
                                                        <h6>
                                                            {isEmptyVariable(this.state.apiSearchKey) ? Constants.NO_RECORDS_WARNING : Constants.EMPTY_SEARCH_WARNING}
                                                        </h6>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="pagination-layout">
                                                <div className="row custom-row">
                                                    <div className="col-md-9 custom-col">
                                                        {this.state.totalCount > this.state.datalist.length && (
                                                            <Pagination
                                                                totalLength={this.state.totalCount}
                                                                items={this.state.datalist}
                                                                onChangePage={this.onChangePage}
                                                                pageSize={this.state.resultSize}
                                                                currentPageNo={this.state.currentPageNo}
                                                                initialPage={this.state.currentPageNo}
                                                                themeSettings={themeSettings}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="col-md-3 custom-col">
                                                        <p>{"Total Records: " + this.state.totalCount}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>

                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialog}
                            handleAlertDialogClose={this.handleAlertDialogClose}
                            type={
                                this.state.operationType === "Delete"
                                    ? Constants.ALERT_TYPE_WARNING
                                    : this.state.operationType === "Review Remarks"
                                    ? Constants.ALERT_TYPE_ALERT
                                    : Constants.ALERT_TYPE_INFO
                            }
                            alertDialogHeading={this.state.alertDialogHeading}
                            alertDialogMessage={this.state.alertDialogMessage}
                            proceedBtnClick={this.handleRecordOperation}
                            proceedBtnLabel={this.state.proceedBtnLabel}
                            showLoader={this.state.showBtnLoader}
                            themeSettings={themeSettings}
                        />

                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                            themeSettings={themeSettings}
                        />
                    </section>
                </main>
            </Router>
        );
    }
}

export default AuditeeDraftAssignmentList;
